/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Grid } from '@material-ui/core'
import swal from 'sweetalert'

import { getManagementPlanMitigations } from '../../../../../../services/Elegibilidad/get'
import { useFormElegibilidad } from '../../../../../../context/ElegibilidadContext'

// import { Modal6Edit } from '../../Modals/ModalSec6Edit/Modal6Edit'
// import GetAppIcon from '@material-ui/icons/GetApp'

const Table61 = ({ idEnviromentalImpact }) => {
  const { EligibilityForm } = useFormElegibilidad()

  const columns = [
    {
      title: 'Medida de Mitigación',
      field: 'MitigationDetail',
      type: 'string',
      cellStyle: { width: '80%' },
    },
    {
      title: 'Inicio',
      field: 'StartDate',
      type: 'date',
      align: 'center',
      dateSetting: {
        format: 'DD/MM/YYYY',
      },
    },
    {
      title: 'Finalización',
      field: 'EndDate',
      type: 'date',
      align: 'center',
      dateSetting: {
        format: 'DD/MM/YYYY',
      },
    },
  ]

  const [body, setBody] = useState({})
  const [openToEdit, setOpenToEdit] = useState(false)
  const [openSec6, setOpenSec6] = useState(false)
  const [tableData, setTableData] = useState([])

  const getDataTable = async (idElegibilityForm, idEnviromentalImpact) => {
    try {
      if (idElegibilityForm) {
        const params = `${idElegibilityForm}/${idEnviromentalImpact}`
        const response = await getManagementPlanMitigations(params)
        if (response && response.Success) {
          setTableData(response.Data)
          if (response.Data.length === 0) {
            // formikSetFielValues(`validateTable${idEnviromentalImpact}`, false)
          } else {
            // formikSetFielValues(`validateTable${idEnviromentalImpact}`, true)
          }
        } else {
          throw Error('No se pudo obtener los registros de la tabla')
        }
      } else {
        throw Error('No se pudo obtener el ID del formulario')
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getDataTable(EligibilityForm.IdElegibilityAnswer, idEnviromentalImpact)
  }, [])

  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData || []}
            // actions={[
            //   {
            //     icon: () => <AddIcon />,
            //     tooltip: 'Agregar',
            //     position: 'toolbar',
            //     onClick: () => {
            //       setOpenToEdit(false)
            //       setOpenSec6(true)
            //     },
            //   },
            //   {
            //     icon: 'edit',
            //     tooltip: 'Editar',
            //     onClick: (event, rowData) => {
            //       setBody(rowData)
            //       setOpenToEdit(true)
            //       setOpenSec6(true)
            //     },
            //   },
            //   {
            //     icon: 'delete',
            //     tooltip: 'Eliminar registro',
            //     onClick: (event, rowData) => {
            //       swal({
            //         title: '¿Está seguro de eliminar el registro?',
            //         icon: 'warning',
            //         buttons: ['No', 'Si'],
            //         dangerMode: true,
            //       })
            //     },
            //   },
            // ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              // search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              // filtering: true,
              paging: false,
              // pageSizeOptions: [2, 5, 10, 20],
              // pageSize: 5,
              // paginationType: 'stepped',
              showFirstLastPageButtons: false,
              // paginationPosition: 'bottom',

              exportFileName: 'TableData',
              // addRowPosition: 'first',
              actionsColumnIndex: -1,
              // selection: true,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              // selectionProps: (rowData) => ({
              //   disabled: rowData.age == null,
              //   // color:"primary"
              // }),
              // grouping: true,
              // columnsButton: true,
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{ Add: () => <AddIcon /> }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default Table61
